import { z } from "zod";

export const TaxonomyCountryItemSchema = z.object({
  Id: z.string(),
  Name: z.string(),
  TwoLetterCode: z.string().optional(),
  ThreeLetterCode: z.string().optional(),
});

export type TaxonomyCountryItemType = z.infer<typeof TaxonomyCountryItemSchema>;
